module.exports = __webpack_public_path__ + "static/img/cw-2.a06776c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/cw-2.jpg
 ** module id = 576
 ** module chunks = 2
 **/